(function (angular) {
    'use strict';

    angular.module('app')
        .service('PromotionsTellMeMoreApi', promotionsTellMeMoreResource);

    promotionsTellMeMoreResource.$inject = [
        'settings',
        '$resource'
    ];

    function promotionsTellMeMoreResource(
        settings,
        $resource
    ) {
        /**
         * Adds extra methods and values. Expectes "this" to be bound to an item object
         * @return {this}
         */
        function transform() {

            return this;
        }

        // Create the resource
        var resource = $resource(settings.apiBase + '/posts/:id/tell-me-more', {}, {
            post: {
                method: 'POST',
                responseType: 'json',
                params: {
                    id: '@id'
                },
            }
        });
        resource.prototype.transform = transform;

        return resource;
    }

}(angular));
